import { Alert, AlertTitle, Link, Collapse } from "@mui/material";
import { useSfdcAuthentication } from "../hooks/useSfdcAuthentication";
import { useSalesforceIntegrationDetailsContext } from "../contexts/useSalesforceIntegrationDetailsContext";

export const ReauthenticationBanner: React.FC = () => {
  const { integration, integrations } =
    useSalesforceIntegrationDetailsContext();

  const existingOrgNames = integrations?.map((org) => org.name) || [];

  const reauthenticate = useSfdcAuthentication({
    isProdEnv: integration.environment === "PRODUCTION",
    orgNames: existingOrgNames,
    reauthenticateIntegrationId: integration.id,
  });

  const handleReconnectClick = (event: React.MouseEvent) => {
    event.preventDefault();
    reauthenticate();
  };

  return (
    <Collapse in={true}>
      <Alert severity="error" sx={{ mb: 2 }}>
        <AlertTitle>Connection Problem</AlertTitle>
        There is a problem connecting to {integration.name}.{" "}
        <Link
          data-testid="salesforce-reauth-banner-link"
          component="button"
          variant="body2"
          onClick={handleReconnectClick}
          sx={{
            textDecoration: "underline",
            color: "inherit",
            fontWeight: "inherit",
          }}
        >
          Please click here to reconnect.
        </Link>
      </Alert>
    </Collapse>
  );
};
